import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import InputField from "components/form/InputField";
import SelectField from "components/form/SelectField";
import TextAreaField from "components/form/TextAreaField";
import DateField from "components/form/DateField";
import FormActionButtons from "components/Button/FormActionButtons";

const EditMitra = () => {
  const navigate = useNavigate();
  const [editIndex, setEditIndex] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  // Format opsi dropdown
  const toOptions = (arr) =>
    arr.map((label) => ({
      id: label.toLowerCase().replace(/\s+/g, "-"),
      label,
    }));

  const jenisPenggunaOptions = toOptions(["MITRA"]);
  const statusAnggotaOptions = toOptions(["Anggota", "Non Anggota"]);
  const jenisMitraOptions = toOptions([
    "Petani",
    "Angkutan",
    "Pemborong",
    "Supplier",
  ]);

  useEffect(() => {
    const mitraToEdit = JSON.parse(localStorage.getItem("editMitra"));
    const allMitra = JSON.parse(localStorage.getItem("mitra")) || [];

    if (mitraToEdit) {
      const index = allMitra.findIndex((m) => m.email === mitraToEdit.email);
      setEditIndex(index);

      // Set semua value dari data yang akan diedit
      for (const key in mitraToEdit) {
        if (Object.prototype.hasOwnProperty.call(mitraToEdit, key)) {
          setValue(key, mitraToEdit[key]);
        }
      }
    }
  }, [setValue]);

  const onSubmit = (data) => {
    const allMitra = JSON.parse(localStorage.getItem("mitra")) || [];
    const updatedMitra = [...allMitra];
    updatedMitra[editIndex] = data;

    localStorage.setItem("mitra", JSON.stringify(updatedMitra));
    localStorage.removeItem("editMitra");
    navigate("/data-mitra");
  };

  return (
    <div className="pl-64 mt-8">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="max-w-4xl p-6 mx-auto bg-white border border-gray-200 shadow-lg rounded-2xl"
      >
        <h2 className="mb-6 text-xl font-semibold text-center text-green-700 sm:text-2xl">
          Edit Data Mitra
        </h2>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* Kolom Kiri */}
          <div className="space-y-4">
            <InputField
              label="Nama"
              {...register("nama", { required: "Nama wajib diisi" })}
              error={errors.nama}
            />
            <InputField
              label="ID Mitra"
              {...register("IDMitra", { required: "ID Mitra wajib diisi" })}
              error={errors.IDMitra}
            />
            <InputField
              label="Nama ID Mitra"
              {...register("NamaIDMitra", {
                required: "Nama ID Mitra wajib diisi",
              })}
              error={errors.NamaIDMitra}
            />
            <SelectField
              label="Jenis Pengguna"
              options={jenisPenggunaOptions}
              {...register("Pengguna", {
                required: "Jenis Pengguna wajib diisi",
              })}
              error={errors.Pengguna}
            />
            <InputField
              label="Kode Pos"
              {...register("KodePos", { required: "Kode Pos wajib diisi" })}
              error={errors.KodePos}
            />
            <InputField
              label="Password"
              type="password"
              readOnly
              {...register("password", { required: true })}
              error={errors.password}
            />
          </div>

          {/* Kolom Kanan */}
          <div className="space-y-4">
            <InputField
              label="No. Telp"
              {...register("telp", { required: "No. Telp wajib diisi" })}
              error={errors.telp}
            />
            <SelectField
              label="Jenis Mitra"
              options={jenisMitraOptions}
              {...register("JenisMitra", {
                required: "Jenis Mitra wajib diisi",
              })}
              error={errors.JenisMitra}
            />
            <DateField
              label="Tanggal Jadi Mitra"
              {...register("TanggalJadiMitra", {
                required: "Tanggal wajib diisi",
              })}
              error={errors.TanggalJadiMitra}
            />
            <SelectField
              label="Status Keanggotaan"
              options={statusAnggotaOptions}
              {...register("StatusKeanggotaan", {
                required: "Status wajib diisi",
              })}
              error={errors.StatusKeanggotaan}
            />
            <InputField
              label="Email"
              type="email"
              {...register("email", {
                required: "Email wajib diisi",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Format email tidak valid",
                },
              })}
              error={errors.email}
            />
            <InputField
              label="Diinput Oleh"
              {...register("DiInputOleh", {
                required: "Wajib diisi",
              })}
              error={errors.DiInputOleh}
            />
          </div>
        </div>

        <div className="mt-6">
          <TextAreaField
            label="Alamat"
            {...register("alamat", { required: "Alamat wajib diisi" })}
            error={errors.alamat}
          />
        </div>

        <FormActionButtons
          submitLabel="Simpan"
          cancelLabel="Batal"
          onCancel={() => navigate("/data-mitra")}
          fullWidth={true}
        />
      </form>
    </div>
  );
};

export default EditMitra;
